module.exports = __webpack_public_path__ + "static/img/banner.10df8c6c.jpg";